import { Component, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ModalsConfirmCardComponent } from "./modals-confirm-card/modals-confirm-card.component";
import { NewAccessCardService } from "../service/new-access-card.service";
import { Router } from "@angular/router";
import { CardPeopleService } from "../service/card-people.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ModalImageAcceptComponent } from "./modal-image-accept/modal-image-accept.component";
import { ThemePalette } from "@angular/material/core";
import { HttpEvent, HttpEventType } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { CustomsValidators } from "../../validators/custom.validators";
import { ModErrorComponent } from "../modals/mod-error/mod-error.component";

@Component({
  selector: "app-new-access-card",
  templateUrl: "./new-access-card.component.html",
  styleUrls: ["./new-access-card.component.css"],
})
export class NewAccessCardComponent implements OnInit {
  buttonEnable: boolean= true
  color: ThemePalette = "primary";
  employee: any;
  formNewcard: UntypedFormGroup;
  formRadio: UntypedFormGroup;
  radioPress = false;
  progress = 0;
  imagesUploaded = "false";
  selectedFiles: File;
  fileName = "false";
  fileError = false;
  disabledItems: any;
  notValid: any;
  excelvalid = true;
  photos: File[];
  urlExcel = environment.urlExampleFileEmployee;
  formTableEntry: any;
  site: any;
  submited: boolean;
  selectpickups: any = [];

  //formData:any;

  //controlsError
  controlMissImage = false;
  controlSizeImageError = false;
  controlFormatImageError = false;

  controlNotFoundError = false;
  controlRepeatPerson = false;
  controlCountryError = false;

  controlImagesFormat = false;
  controlImagesSize = false;
  imagesNotmatch = false;

  filesize = false;
  fileformat = false;
  selectCountry: any;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private dataApi: NewAccessCardService,
    private dataApiCard: CardPeopleService,
    public dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private router: Router,
    private spinner: NgxSpinnerService
  ) {
    this.formTableEntry = [];
  }
  getlang() {
    return sessionStorage.getItem("lang");
  }
  getallsitespickups() {
    this.spinner.show("loading");
    this.dataApi.getallsitespickups().subscribe((data: any) => {
      this.site = data.sites;
      this.selectCountry = data.countries;
      this.spinner.hide("loading");
    });
  }
  downloadExcel() {
    window.window.open(this.urlExcel);
  }

  ngOnInit() {
    this.formRadio = this.formBuilder.group({
      options: ["", Validators.required],
      ID: [
        "",
        [
          Validators.required,
          Validators.maxLength(10),
          CustomsValidators.validateRUN,
        ],
      ],
      document: ["nationalId", Validators.required],
      countryId: ["", Validators.required],
    });
    this.formNewcard = this.formBuilder.group({
      siteId: ["", Validators.required],
      pickupId: ["", Validators.required],
      Confirm: [false, Validators.required],
    });
    this.getallsitespickups();
  }

  onSubmit() {
    this.controlRepeatPerson = false;
    this.controlMissImage = false;
    this.submited = true;
    if (this.isrequired("siteId")) {
      this.goTo("siteSelect");
      return;
    } else {
      if (this.isrequired("pickupId")) {
        this.goTo("pickSelect");
        return;
      } else {
        if (this.formRadio.controls.options.hasError("required")) {
          this.goTo("manual");
          return;
        }
        if (!this.isrequired("Confirm") && this.formNewcard.valid) {
          if (this.formTableEntry.length > 0) {
            const cardRequest = {
              PickupId: Number(this.formNewcard.value.pickupId),
              SiteId: Number(this.formNewcard.value.siteId),
              Type: true,
              People: [],
            };
            if (this.formRadio.value.options === "manual") {
              Object.assign(cardRequest, { Bulk: false });
              for (const item of this.formTableEntry) {
                if (item.request_access_card) {
                  if (item.image) {
                    cardRequest.People.push({
                      ImageData: item.image,
                      MDMID: item.mdmid,
                    });
                  } else {
                    this.controlMissImage = true;
                    return;
                  }
                }
              }
              if (cardRequest.People.length > 10) {
                this._snackBar.open(
                  "you can enter a maximum of 10 people",
                  "",
                  {
                    duration: 3000,
                  }
                );
                return;
              }
            } else if (this.formRadio.value.options === "bulk") {
              Object.assign(cardRequest, { Bulk: true });
              for (const item of this.formTableEntry) {
                if (item.ImageFile) {
                  cardRequest.People.push({
                    MDMID: item.mdmid,
                    ImageFile: item.ImageFile,
                  });
                } else {
                  this.controlMissImage = true;
                  return;
                }
              }
            }

            if (cardRequest.People.length > 0) {
              this.spinner.show("uploading");
              this.dataApi.postnewcard(cardRequest).subscribe(
                (event: HttpEvent<any>) => {
                  switch (event.type) {
                    case HttpEventType.Sent:
                      break;
                    case HttpEventType.ResponseHeader:
                      break;
                    case HttpEventType.UploadProgress:
                      this.progress = Math.round(
                        (event.loaded / event.total) * 100
                      );

                      break;
                    case HttpEventType.Response:
                      if (event.status === 200) {
                        this.router.navigate([
                          "/card-confirmation/" + event.body.requestNumber,
                        ]);
                        this.spinner.hide("uploading");
                      }
                      setTimeout(() => {
                        this.progress = 0;
                      }, 1500);
                  }
                },
                (err) => {
                  this.spinner.hide("uploading");
                  if(err.error.error !== 'Invalid token.') {
                    this.dialog.open(ModErrorComponent, {
                      width: 'auto',
                      panelClass: 'myapp-no-padding-dialog',
                    });
                  }
                }
              );
            } else {
              this._snackBar.open("Invalid people, try again");
            }
          }
        }
      }
    }
  }

  isrequired(atrr) {
    return this.formNewcard.controls[atrr].hasError("required");
  }

  goTo(id: string) {
    const el = document.getElementById(id);
    el.scrollIntoView();
  }

  openDialogConfirm() {
    this.dialog
      .open(ModalsConfirmCardComponent, {
        panelClass: "myapp-no-padding-dialog",
      })
      .afterClosed()
      .subscribe((accept: boolean) => {
        if (accept) {
          this.formNewcard.controls["Confirm"].setValue(true);
        } else {
        }
      });
  }

  changeSelect(pickup) {
    for (const siteOP of this.site) {
      if (siteOP.site_id === Number(pickup)) {
        this.selectpickups = siteOP.pickup;
 console.log ('Este es el site',siteOP.site_name,this.site)
        if (siteOP.site_name==='') //applying same solution given to b511 conditions 
        {
          
          this.buttonEnable = false
         
        }
        else 
        {
          this.buttonEnable= true

        }
      }
      this.formNewcard.controls["pickupId"].setValue("");
    }
  }

  newpeople(peopleID) {
    let DoSearch = true;
    this.spinner.show("loading");
    for (const person of this.formTableEntry) {
      if (
        //person.type === "Rut" &&
        this.formRadio.value.document === "nationalId"
      ) {
        if (String(person.nationalId).toLowerCase() === String(peopleID).toLowerCase()) {

          DoSearch = false;
          this.spinner.hide("loading");
          break;
        }
      } else if (
        //person.type === "Passport" &&
        this.formRadio.value.document === "passportNumber"
      ) {
        if (
          String(person.passportNumber).toLowerCase() === String(peopleID).toLowerCase() &&
          this.formRadio.value.countryId == person.nationality
        ) {
          DoSearch = false;
          this.spinner.hide("loading");
          break;
        }
      }
    }
    if (DoSearch) {
      this.dataApiCard
        .ValidatePeople(
          this.formRadio.value.document,
          peopleID.toLowerCase(),
          this.formRadio.value.countryId,
          "new"
        )
        .subscribe(
          (data: any) => {
            this.radioPress = false;
            if (data.peopleIn != null) {
              const newEntry = {
                mdmid: data.peopleIn.mdmid,
                full_name: data.peopleIn.firstName + " " + data.peopleIn.lastName,
                request_access_card: true,
                email: null,
                nationalId: data.peopleIn.nationalId,
                passportNumber: data.peopleIn.passportNumber,
                type: null,
                nationality: data.peopleIn.nationality,
              };
              if (data.peopleIn.employeeType.trim() == "Employee") {
                // Object.assign(newEntry, { email: data.peopleIn.email });
                newEntry.email = data.peopleIn.email;
              } else {
                // Object.assign(newEntry, { email: data.peopleIn.companyEmail });
                newEntry.email = data.peopleIn.companyEmail;
              }
              if (data.peopleIn.nationalId) {
                /*
            Object.assign(newEntry, {
              nationalId: data.peopleIn.nationalId,
              type: 'Rut'
            });
            */
                //newEntry.nationalId = data.peopleIn.nationalId;
                newEntry.type = "Rut";
              } else {
                /*
            Object.assign(newEntry, {
              passportNumber: data.peopleIn.passportNumber,
              type: 'Passport',
              nationality: data.peopleIn.nationality
            });
            */
                //newEntry.nationalId = data.peopleIn.passportNumber;
                newEntry.type = "Passport";
                //newEntry.nationality = data.peopleIn.nationality;
              }
              this.formTableEntry.push(newEntry);
              this.spinner.hide("loading");
            } else if (data.peopleNotValid != null) {
              const newEntry = {
                mdmid: data.peopleNotValid.mdmid,
                full_name:
                  data.peopleNotValid.firstName +
                  " " +
                  data.peopleNotValid.lastName,
                request_access_card: false,
                email: null,
                nationalId: data.peopleNotValid.nationalId,
                passportNumber: data.peopleNotValid.passportNumber,
                type: null,
                nationality: data.peopleNotValid.nationality,
              };
              if (data.peopleNotValid.employeeType.trim() == "Employee") {
                // Object.assign(newEntry, { email: data.peopleNotValid.email });
                newEntry.email = data.peopleNotValid.email;
              } else {
                // Object.assign(newEntry, { email: data.peopleNotValid.companyEmail });
                newEntry.email = data.peopleNotValid.companyEmail;
              }
              if (data.peopleNotValid.nationalId) {
                // Object.assign(newEntry, { nationalId: data.peopleNotValid.nationalId, type: 'Rut' });
                //newEntry.nationalId = data.peopleNotValid.nationalId;
                newEntry.type = "Rut";
              } else {
                /*
            Object.assign(newEntry, {
              passportNumber: data.peopleNotValid.passportNumber, type: 'Passport',
              nationality: data.peopleNotValid.nationality
            });
            */
                //newEntry.nationalId = data.peopleNotValid.passportNumber;
                newEntry.type = "Passport";
                //newEntry.nationality = data.peopleNotValid.nationality;
              }
              this.formTableEntry.push(newEntry);
              this.spinner.hide("loading");
            }
            if (data.peopleOut) {
              this.spinner.hide("loading");
              this.controlNotFoundError = true;
            }
            this.spinner.hide("loading");
          },
          (err) => {
            this.spinner.hide("loading");
            if(err.error.error !== 'Invalid token.') {
              this.dialog.open(ModErrorComponent, {
                width: 'auto',
                panelClass: 'myapp-no-padding-dialog',
              });
            }
          }
        );
    } else {
      this.spinner.hide("loading");
      this.controlRepeatPerson = true;
    }
  }
  detectFiles(event) {
    //Excel --
    this.filesize = false;
    this.fileformat = false;
    const FileEx = event.target.files[0];
    const names = FileEx.name.split(".");
    const formData = new FormData();

    formData.append("file", FileEx);
    this.formTableEntry = [];
    this.disabledItems = {};
    this.notValid = null;
    this.spinner.show("loading");
    if (
      !(
        FileEx.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
        names[names.length - 1].toLocaleLowerCase() === "xlsx"
      )
    ) {
      this.spinner.hide("loading");
      this.fileName = "false";
      this.fileformat = true;
      event.srcElement.value = null;
      return;
    } else {
      this.fileName = FileEx.name;
      this.fileformat = false;
    }
    if (FileEx.size >= 15000000) {
      this.filesize = true;
      event.srcElement.value = null;
      this.spinner.hide("loading");
      return;
    }
    this.fileName = FileEx.name;
    this.dataApiCard.ValidatePeopleExcel(formData).subscribe(
      (data: any) => {
        this.formTableEntry = data.peopleIn;
        this.disabledItems = data.peopleNotValid;
        this.notValid = data.peopleOut;
        this.excelvalid = true;
        event.srcElement.value = null;
        this.spinner.hide("loading");
      },
      (err) => {
        this.excelvalid = false;
        this.spinner.hide("loading");
        if(err.error.error !== 'Invalid token.') {
          this.dialog.open(ModErrorComponent, {
            width: 'auto',
            panelClass: 'myapp-no-padding-dialog',
          });
        }
        event.srcElement.value = null;
      }
    );
  }

  uploadPhotos(event) {
    this.imagesUploaded = "ready";
    let added = false;
    this.controlImagesFormat = false;
    this.controlImagesSize = false;
    this.imagesNotmatch = false;

    for (const photo of event.target.files) {
      if (String(photo.name.split(".")[photo.name.split(".").length - 1]).toLocaleLowerCase() != "jpg") {
        this.controlImagesFormat = true;
        event.srcElement.value = null;
        this.imagesUploaded = "false";
        return;
      }
      if (photo.type != "image/jpeg") {
        this.controlImagesFormat = true;
        event.srcElement.value = null;
        this.imagesUploaded = "false";
        return;
      }
      if (photo.size >= 2000000) {
        this.controlImagesSize = true;
        event.srcElement.value = null;
        this.imagesUploaded = "false";
        return;
      }
    }
    for (const photo of event.target.files) {
      for (let i = 0; i < this.formTableEntry.length; i++) {
        if (
          photo.name.split(".")[0].trim().toLocaleLowerCase() === this.formTableEntry[i].nationalId.toLocaleLowerCase() ||
          photo.name.split(".")[0].trim().toLocaleLowerCase() === this.formTableEntry[i].passportNumber.toLocaleLowerCase()
        ) {
          if (!added) {
            added = true;
          }
          Object.assign(this.formTableEntry[i], { ImageFile: photo });
        }
      }
    }
    event.srcElement.value = null;
    if (added) {
    } else {
      this.imagesUploaded = "false";
      this.imagesNotmatch = true;
    }
  }
  add() {
    this.controlRepeatPerson = false;
    this.controlNotFoundError = false;
    this.radioPress = true;
    this.controlCountryError = false;
    if (!this.formRadio.controls["document"].hasError("required")) {
      if (!this.formRadio.controls["ID"].hasError("required")) {
        if (
          this.formRadio.value.document === "passportNumber" &&
          this.formRadio.controls["countryId"].hasError("required")
        ) {
          //validation of nationality pending
          this.spinner.hide("loading");
          this.controlCountryError = true;
          return;
        } else if (
          this.formRadio.value.document === "nationalId" &&
          this.formRadio.controls["ID"].hasError("validateRUN")
        ) {
          this.spinner.hide("loading");
          return;
        } else if (
          this.formRadio.value.document === "nationalId" &&
          !this.formRadio.controls["ID"].hasError("validateRUN")
        ) {
          let IdSPLIT = this.formRadio.value.ID.split(".").join("");
          this.formRadio.controls["ID"].setValue(IdSPLIT);
        }

        this.newpeople(this.formRadio.value.ID);
      }
    }
  }

  deletePeople(i) {
    this.formTableEntry.splice(i, 1);
  }
  deletePeopleDisabled(i) {
    this.disabledItems.splice(i, 1);
  }
  deletePeopleNotfound(i) {
    this.notValid.splice(i, 1);
  }

  cleanBulk() {
    this.submited = false;
    this.formTableEntry = [];
    this.disabledItems = [];
    this.notValid = [];
    this.fileName = "false";
  }
  cleanManual() {
    this.formTableEntry = [];
    this.submited = false;
  }

  changeListener($event, index): void {
    if ($event.target.files.length <= 0) {
      return;
    }
    /*
    Object.assign(this.formTableEntry[index], {
      sizeImageError: false,
      formatImageError: false,
      controlNameImageError: false,
    });
    */
    const newEntry = {
      email: this.formTableEntry[index].email,
      full_name: this.formTableEntry[index].full_name,
      mdmid: this.formTableEntry[index].mdmid,
      nationalId: this.formTableEntry[index].nationalId,
      passportNumber: this.formTableEntry[index].passportNumber,
      nationality: this.formTableEntry[index].nationality,
      request_access_card: this.formTableEntry[index].request_access_card,
      type: this.formTableEntry[index].type,
      formatImageError: false,
      sizeImageError: false,
      controlNameImageError: false,

      image_name: null,
      image: null,
    };
    this.formTableEntry[index] = newEntry;

    let nationalIdImage = this.formTableEntry[index].nationalId == null ? '' : this.formTableEntry[index].nationalId;
    let passportImage = this.formTableEntry[index].passportNumber == null ? '' : this.formTableEntry[index].passportNumber;

    if ($event.target.files[0].type === "image/jpeg" || $event.target.files[0].type === "image/jpg") {

      if ($event.target.files[0].size <= 2000000) {
        if (
          !(
            $event.target.files[0].name.toLocaleLowerCase().split(".jp")[0].trim() === this.formTableEntry[index].nationalId.toLocaleLowerCase() ||
            $event.target.files[0].name.toLocaleLowerCase().split(".")[0].trim() === this.formTableEntry[index].passportNumber.toLocaleLowerCase()
          )
        ) {
          // Object.assign(this.formTableEntry[index], { controlNameImageError: true});
          newEntry.controlNameImageError = true;
          this.formTableEntry[index] = newEntry;
          $event.srcElement.value = null;
          delete this.formTableEntry[index].image_name;
          delete this.formTableEntry[index].image;
          this.spinner.hide("loading");
          return;
        }
        this.dialog
          .open(ModalImageAcceptComponent, {
            data: $event.target,
            panelClass: "myapp-no-padding-dialog",
          })
          .afterClosed()
          .subscribe((result: any) => {
            this.spinner.show("loading");
            if (result != null) {
              /*
              Object.assign(this.formTableEntry[index], {
                image_name: result.image_name,
                image: result.image,
                sizeImageError: false,
                formatImageError: false,
                controlNameImageError: false,
              });
              */
              newEntry.image_name = result.image_name;
              newEntry.image = result.image;
              newEntry.sizeImageError = false;
              newEntry.formatImageError = false;
              newEntry.controlNameImageError = false;
              this.formTableEntry[index] = newEntry;
              $event.srcElement.value = null;
            } else {
              $event.srcElement.value = null;
            }
            this.spinner.hide("loading");
          });
      } else {
        // Object.assign(this.formTableEntry[index], { sizeImageError: true});
        newEntry.sizeImageError = true;
        this.formTableEntry[index] = newEntry;
        $event.srcElement.value = null;
      }
    } else {
      // Object.assign(this.formTableEntry[index], { formatImageError: true });
      newEntry.formatImageError = true;
      this.formTableEntry[index] = newEntry;
      $event.srcElement.value = null;
    }
  }
}
